var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigWhiteCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 64,
    viewBox: "0 0 264 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_965_28555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 244,
    height: 44,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.243 40.625L141.339 32.9469C141.468 32.8009 141.569 32.6287 141.637 32.4402C141.779 32.0663 141.779 31.647 141.637 31.2731C141.569 31.0846 141.468 30.9124 141.339 30.7664L134.243 23.0883C134.11 22.9452 133.953 22.8316 133.78 22.7541C133.608 22.6766 133.422 22.6367 133.235 22.6367C132.857 22.6367 132.495 22.7992 132.227 23.0883C131.96 23.3775 131.81 23.7697 131.81 24.1786C131.81 24.5876 131.96 24.9797 132.227 25.2689L136.911 30.321L124.72 30.321C124.344 30.321 123.983 30.4828 123.716 30.7708C123.45 31.0588 123.301 31.4494 123.301 31.8567C123.301 32.2639 123.45 32.6545 123.716 32.9425C123.983 33.2305 124.344 33.3923 124.72 33.3923L136.911 33.3923L132.227 38.4444C132.094 38.5872 131.989 38.757 131.917 38.9441C131.845 39.1313 131.808 39.332 131.808 39.5347C131.808 39.7374 131.845 39.9381 131.917 40.1252C131.989 40.3124 132.094 40.4822 132.227 40.625C132.359 40.7689 132.516 40.8831 132.689 40.9611C132.862 41.0391 133.048 41.0792 133.235 41.0792C133.422 41.0792 133.608 41.0391 133.781 40.9611C133.954 40.8831 134.111 40.7689 134.243 40.625Z",
    fill: "#1865C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_965_28555",
    x: 0,
    y: 0,
    width: 264,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_965_28555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_965_28555",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigWhiteCta);
export default __webpack_public_path__ + "static/media/big_white_cta.b9e19a99ba2dc465b966281297de76cb.svg";
export { ForwardRef as ReactComponent };